import { __rest } from "tslib";
/**
 * 车辆管理 - 车辆数据操作
 * */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import { dispatch } from '@@/store';
import API from '@/services';
export default createStore({
    state: {},
    effects: {
        // 添加买家信息
        addBuyerMsg(addData) {
            const { auctionId, phoneCode, callback } = addData;
            const req = {
                auctionId,
                phoneCode,
            };
            API.auction.addBuyerInfo(req)
                .then((res) => {
                // 成交
                this.dealCar({
                    auctionId: addData.auctionId,
                    callback,
                });
            });
        },
        // 成交
        dealCar(dealData) {
            const { callback } = dealData, deal = __rest(dealData, ["callback"]);
            API.auction.dealAuction(Object.assign(Object.assign({}, deal), { dealId: 1 }))
                .then((res) => {
                notification.success({
                    message: '车辆成交操作成功',
                });
                callback && callback(res);
                dispatch.carState.getEveryStateCarNum({});
            });
        },
        // 流拍
        flowAuction(flowData) {
            const { callback } = flowData, flow = __rest(flowData, ["callback"]);
            API.auction.dealAuction(Object.assign(Object.assign({}, flow), { dealId: 2 }))
                .then((res) => {
                notification.success({
                    message: '车辆流拍操作成功',
                });
                callback && callback(res);
                dispatch.carState.getEveryStateCarNum({});
            });
        },
        // 暗拍竞拍中流拍（下架）
        abortive(abortiveData) {
            const { callback } = abortiveData, abortiveProps = __rest(abortiveData, ["callback"]);
            API.auction.setAuctionFailed(abortiveProps.auctionIdStr).then((res) => {
                notification.success({
                    message: '操作成功',
                });
                callback && callback();
                dispatch.carState.getEveryStateCarNum({});
            });
        },
        // 是否可以下架
        checkCanOutOfStock(data, { state }) {
            return API.auction.selectHigherBasePrice(data.auctionIdStr);
        },
        // 下架
        offShelf(offData) {
            const { callback } = offData, offParams = __rest(offData, ["callback"]);
            API.auction.takeOffAuctioningGoods(offParams).then((res) => {
                notification.success({
                    message: '操作成功',
                });
                callback && callback();
                dispatch.carState.getEveryStateCarNum({});
            });
        },
        // 违约
        // 正常成交
        // 撮合成交
        // 交易失败
        dealFail(failData) {
            const { callback } = failData, fail = __rest(failData, ["callback"]);
            API.goods.confirmFailTrade(fail)
                .then((res) => {
                notification.success({
                    message: '流拍车辆交易失败操作成功',
                });
                callback && callback();
                dispatch.carState.getEveryStateCarNum({});
            })
                .catch((err) => {
                notification.error({
                    message: '操作失败，请重试',
                });
            });
        },
        // 重新发拍 & 创建场次发拍
        // 退回流拍
        returnAuction(returnData) {
            const { callback, data } = returnData;
            API.goods.backAbortiveByIdList({
                goodsIdList: JSON.stringify(data),
            })
                .then((res) => {
                notification.success({
                    message: `${res},车辆进入流拍列表`,
                });
                callback && callback();
                dispatch.carState.getEveryStateCarNum({});
            });
        },
        // 申请向卖家付款
        applyToSellerPay({ idList, callback }, { state }) {
            API.order.applicationSellerPay({
                orderIds: JSON.stringify(idList),
            }).then((res) => {
                if (res) {
                    notification.success({
                        message: '向卖家申请付款成功',
                    });
                    callback && callback(true);
                }
            })
                .catch((data) => {
                if (data.code === '20001' || data.code === '20002') {
                    callback && callback(false);
                }
                notification.error({
                    message: '向卖家申请付款失败',
                });
            });
        },
    },
    reducers: {},
});
